import type { CustomIconProps } from '../CustomIcon';

export const LikeIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 24,
  ...props
}: CustomIconProps) => (
  <svg width={size} height={size} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M14 5v4h5.66a2 2 0 0 1 2 2.3l-1.38 9a2 2 0 0 1-2 1.7H7V11l4-9a3 3 0 0 1 3 3Z'
      fill={color}
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3'
      fill={secondaryColor}
      stroke={secondaryColor}
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
